import Cookies from "js-cookie";

export abstract class LocalDataSource {
  protected setCookie(
    key: string,
    value: string | object,
    expires?: number | Date
  ): void {
    Cookies.set(key, value, { expires });
  }

  protected getCookie(key: string): string | undefined {
    return Cookies.get(key);
  }

  protected deleteCookie(key: string): void {
    Cookies.remove(key);
  }
}
